<div class="mb-4">
  <h4 class="mb-2">{{ title }}</h4>

  <div class="row">
    <div class="col-md-6" *ngFor="let workflow of workflows">
      <wm-workflow-item [workflow]="workflow"></wm-workflow-item>
    </div>
  </div>
</div>
